"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Interaction = void 0;
var action_tracker_1 = require("../action-tracker/action_tracker");
var Interaction = /** @class */ (function () {
    function Interaction(_a) {
        var authorization = _a.authorization, applicationId = _a.applicationId, endpoint = _a.endpoint;
        this.describeElement = function (el) {
            var params = {
                classes: el.className
                    ? el.className.split(' ').filter(function (str) { return str.length > 0; })
                    : [],
            };
            Object.assign(params, el.dataset.component
                ? { component: el.dataset.component }
                : null, el.dataset.label ? { label: el.dataset.label } : null);
            return params;
        };
        this.actionTracker = new action_tracker_1.ActionTracker({ authorization: authorization, endpoint: endpoint, applicationId: applicationId });
    }
    Interaction.prototype.track = function (eventName, args) {
        var params = this.transformParams(eventName, this.trackableParams(args));
        return this.actionTracker.track(params);
    };
    Interaction.prototype.isVisible = function (el) {
        var _a = el.getBoundingClientRect(), top = _a.top, bottom = _a.bottom;
        var vHeight = window.innerHeight || document.documentElement.clientHeight;
        return (top > 0 || bottom > 0) && top < vHeight;
    };
    Interaction.prototype.transformParams = function (eventName, args) {
        var customEventData = this.customParams(eventName, args);
        var params = {
            page: this.pageParams(args),
            domEventData: this.domParams(args),
            pageRequestId: args.request_id || 'undefined',
            window: this.windowParams(),
        };
        if (customEventData) {
            params.customEventData = customEventData;
        }
        if (args.leadFormId) {
            params.leadFormEventData = this.leadFormParams(args);
        }
        return params;
    };
    Interaction.prototype.windowParams = function () {
        return {
            height: window.innerHeight,
            width: window.innerWidth,
            visibleElements: Array.from(document.querySelectorAll('[data-component]'))
                .filter(this.isVisible)
                .map(this.describeElement),
        };
    };
    Interaction.prototype.getMeta = function (name) {
        var meta = document.querySelector("meta[name=".concat(name, "]"));
        return meta ? meta.content : null;
    };
    Interaction.prototype.pageParams = function (args) {
        var params = {
            url: location.href,
            divisionId: args.division_id || 'VT::VT',
            userAgent: navigator.userAgent,
            contentVersion: args.content_version || this.getMeta('content-version'),
            visitorId: this.getMeta('visitor-id'),
            nspSlug: this.getMeta('nsp-slug') || '',
            nspSlugType: this.getMeta('nsp-slug-type') || '',
        };
        // Only set session id if we have one
        var optionals = {
            sessionId: 'session_id',
            userId: 'user_id',
            clientUuid: 'client_uuid',
        };
        Object.keys(optionals).forEach(function (key) {
            if (args[optionals[key]]) {
                params[key] = args[optionals[key]];
            }
        });
        if (args.ab_test_experiment && args.ab_test_variant) {
            params.tests = [
                {
                    experimentId: args.ab_test_experiment,
                    variantId: args.ab_test_variant,
                },
            ];
        }
        return params;
    };
    Interaction.prototype.domParams = function (args) {
        // Required values
        var params = {
            target: args.target,
        };
        var includeDataAttributes = args.dataAttributes &&
            typeof args.dataAttributes == 'object' &&
            Object.keys(args.dataAttributes).length > 0;
        // Optional values
        Object.assign(params, args.className ? { classes: args.className.split(' ') } : null, args.text ? { text: args.text } : null, args.fieldValue ? { value: args.fieldValue } : null, args.fieldName ? { name: args.fieldName } : null, includeDataAttributes ? { data: args.dataAttributes } : null);
        return params;
    };
    Interaction.prototype.customParams = function (eventName, args) {
        if (!args.category)
            return undefined; // category is required by CustomEventData
        return {
            action: eventName,
            category: args.category,
            label: args.label,
            value: args.value,
        };
    };
    Interaction.prototype.leadFormParams = function (args) {
        // Required values
        var params = { id: args.leadFormId };
        // Optional values
        Object.assign(params, args.panelId != null ? { panel: args.panelId } : null);
        return params;
    };
    Interaction.prototype.trackableParams = function (args) {
        var _a;
        var tracking = ((_a = window.components) === null || _a === void 0 ? void 0 : _a.tracking) || {};
        var params = __assign(__assign(__assign({}, this.urlParams()), tracking), args);
        params.param_string = location.search;
        params.path = location.pathname;
        return params;
    };
    Interaction.prototype.urlParams = function () {
        if (!window.location.search)
            return {};
        var json = '{"' +
            decodeURI(window.location.search
                .replace(/^\?/, '')
                .replace(/^&/, '')
                .replace(/&$/, '')
                .replace(/&/g, '","')
                .replace(/=/g, '":"')
                // Unescape double quotes (URLEncode %22) properly before it can be decoded
                .replace(/%22/g, '\\"')) +
            '"}';
        return JSON.parse(json);
    };
    return Interaction;
}());
exports.Interaction = Interaction;
